import React from 'react';

import { Dot } from './styles';

interface Props {
  lat: number;
  lng: number;
}

const MapPin = ({ lat, lng }: Props) => <Dot />;

export default MapPin;
